export const STEP_ON_OPTIONS = [
  { value: '*',       label: 'Any Day' },
  { value: 'mon-fri', label: 'Mon-Fri' },
  { value: 'mon-sat', label: 'Mon-Sat' },
  { value: 'sat-sun', label: 'Sat-Sun' },
  { value: 'sun',     label: 'Sunday' },
  { value: 'mon',     label: 'Monday' },
  { value: 'tue',     label: 'Tuesday' },
  { value: 'wed',     label: 'Wednesday' },
  { value: 'thu',     label: 'Thursday' },
  { value: 'fri',     label: 'Friday' },
  { value: 'sat',     label: 'Saturday' },
];
